/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MediaFile } from './MediaFile';
import {
    MediaFileFromJSON,
    MediaFileFromJSONTyped,
    MediaFileToJSON,
} from './MediaFile';

/**
 * Full visit form object returned by GET and PATCH endpoints.
 * @export
 * @interface VisitFormDraft
 */
export interface VisitFormDraft {
    /**
     * Visit form UUID
     * @type {string}
     * @memberof VisitFormDraft
     */
    id: string;
    /**
     * Property address
     * @type {string}
     * @memberof VisitFormDraft
     */
    propertyAddress: string;
    /**
     * Associated listing UUID (if found)
     * @type {string}
     * @memberof VisitFormDraft
     */
    listingId?: string;
    /**
     * Associated disposition UUID (if found)
     * @type {string}
     * @memberof VisitFormDraft
     */
    dispositionId?: string;
    /**
     * Email of agent assigned to the form
     * @type {string}
     * @memberof VisitFormDraft
     */
    assignedAgentEmail: string;
    /**
     * Agent's first name
     * @type {string}
     * @memberof VisitFormDraft
     */
    assignedAgentFirstName?: string;
    /**
     * Agent's last name
     * @type {string}
     * @memberof VisitFormDraft
     */
    assignedAgentLastName?: string;
    /**
     * Current section number (1-14)
     * @type {number}
     * @memberof VisitFormDraft
     */
    currentSection: number;
    /**
     * Completed section numbers
     * @type {Array<number>}
     * @memberof VisitFormDraft
     */
    sectionsCompleted: Array<number>;
    /**
     * Visit form status: 'not_assigned', 'assigned', 'in_progress', 'complete', or 'expired'
     * @type {string}
     * @memberof VisitFormDraft
     */
    status: string;
    /**
     * All form field data
     * @type {{ [key: string]: any; }}
     * @memberof VisitFormDraft
     */
    formData: { [key: string]: any; };
    /**
     * Type of visit
     * @type {string}
     * @memberof VisitFormDraft
     */
    visitType?: string;
    /**
     * Type of the visit this form reports on (e.g. 'Occupied Prewalk'); visit_type is the form type
     * @type {string}
     * @memberof VisitFormDraft
     */
    parentVisitType?: string;
    /**
     * Agent type: 'flex' or 'preferred'
     * @type {string}
     * @memberof VisitFormDraft
     */
    agentType: string;
    /**
     * Invoicing preference: 'in-house' or 'showami'
     * @type {string}
     * @memberof VisitFormDraft
     */
    invoicing: string;
    /**
     * Uploaded media files
     * @type {Array<MediaFile>}
     * @memberof VisitFormDraft
     */
    media?: Array<MediaFile>;
    /**
     * Creation timestamp
     * @type {Date}
     * @memberof VisitFormDraft
     */
    createdAt: Date;
    /**
     * Last update timestamp
     * @type {Date}
     * @memberof VisitFormDraft
     */
    updatedAt: Date;
    /**
     * When agent was assigned
     * @type {Date}
     * @memberof VisitFormDraft
     */
    assignedAt?: Date;
    /**
     * When form was started (status changed to in_progress)
     * @type {Date}
     * @memberof VisitFormDraft
     */
    startedAt?: Date;
    /**
     * When form was completed
     * @type {Date}
     * @memberof VisitFormDraft
     */
    completedAt?: Date;
    /**
     * When form was submitted
     * @type {Date}
     * @memberof VisitFormDraft
     */
    submittedAt?: Date;
    /**
     * Reason for the last reviewer status change
     * @type {string}
     * @memberof VisitFormDraft
     */
    statusChangeReason?: string;
}

/**
 * Check if a given object implements the VisitFormDraft interface.
 */
export function instanceOfVisitFormDraft(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "propertyAddress" in value;
    isInstance = isInstance && "assignedAgentEmail" in value;
    isInstance = isInstance && "currentSection" in value;
    isInstance = isInstance && "sectionsCompleted" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "formData" in value;
    isInstance = isInstance && "agentType" in value;
    isInstance = isInstance && "invoicing" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function VisitFormDraftFromJSON(json: any): VisitFormDraft {
    return VisitFormDraftFromJSONTyped(json, false);
}

export function VisitFormDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitFormDraft {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'propertyAddress': json['property_address'],
        'listingId': !exists(json, 'listing_id') ? undefined : json['listing_id'],
        'dispositionId': !exists(json, 'disposition_id') ? undefined : json['disposition_id'],
        'assignedAgentEmail': json['assigned_agent_email'],
        'assignedAgentFirstName': !exists(json, 'assigned_agent_first_name') ? undefined : json['assigned_agent_first_name'],
        'assignedAgentLastName': !exists(json, 'assigned_agent_last_name') ? undefined : json['assigned_agent_last_name'],
        'currentSection': json['current_section'],
        'sectionsCompleted': json['sections_completed'],
        'status': json['status'],
        'formData': json['form_data'],
        'visitType': !exists(json, 'visit_type') ? undefined : json['visit_type'],
        'parentVisitType': !exists(json, 'parent_visit_type') ? undefined : json['parent_visit_type'],
        'agentType': json['agent_type'],
        'invoicing': json['invoicing'],
        'media': !exists(json, 'media') ? undefined : ((json['media'] as Array<any>).map(MediaFileFromJSON)),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'assignedAt': !exists(json, 'assigned_at') ? undefined : (new Date(json['assigned_at'])),
        'startedAt': !exists(json, 'started_at') ? undefined : (new Date(json['started_at'])),
        'completedAt': !exists(json, 'completed_at') ? undefined : (new Date(json['completed_at'])),
        'submittedAt': !exists(json, 'submitted_at') ? undefined : (new Date(json['submitted_at'])),
        'statusChangeReason': !exists(json, 'status_change_reason') ? undefined : json['status_change_reason'],
    };
}

export function VisitFormDraftToJSON(value?: VisitFormDraft | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'property_address': value.propertyAddress,
        'listing_id': value.listingId,
        'disposition_id': value.dispositionId,
        'assigned_agent_email': value.assignedAgentEmail,
        'assigned_agent_first_name': value.assignedAgentFirstName,
        'assigned_agent_last_name': value.assignedAgentLastName,
        'current_section': value.currentSection,
        'sections_completed': value.sectionsCompleted,
        'status': value.status,
        'form_data': value.formData,
        'visit_type': value.visitType,
        'parent_visit_type': value.parentVisitType,
        'agent_type': value.agentType,
        'invoicing': value.invoicing,
        'media': value.media === undefined ? undefined : ((value.media as Array<any>).map(MediaFileToJSON)),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
        'assigned_at': value.assignedAt === undefined ? undefined : (value.assignedAt.toISOString()),
        'started_at': value.startedAt === undefined ? undefined : (value.startedAt.toISOString()),
        'completed_at': value.completedAt === undefined ? undefined : (value.completedAt.toISOString()),
        'submitted_at': value.submittedAt === undefined ? undefined : (value.submittedAt.toISOString()),
        'status_change_reason': value.statusChangeReason,
    };
}

